import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  variant,
  color,
  width,
  border,
  background,
  opacity,
  fontWeight,
  fontSize,
  margin,
  padding,
} from 'styled-system';
import { Variant } from '../../utils/constants';

const SelectStyled = styled('select')`
  ${width};
  ${border};
  ${background};
  ${opacity};
  ${opacity};
  ${fontWeight};
  ${fontSize};
  ${color};
  ${margin};
  ${padding};
  outline: none;
  line-height: 20px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
`;

SelectStyled.defaultProps = {
  width: 1,
  border: 'none',
  background: 'transparent',
  color: 'greyDark',
  opacity: 0,
  fontWeight: 400,
  fontSize: 16,
  margin: 0,
  padding: 0,
};

const Select = styled(SelectStyled)(
  variant({
    variants: {
      [Variant.Success]: {
        color: 'darkBlack',
        paddingTop: 4,
      },
    },
  })
);

Select.displayName = 'Select';

const Option = styled.option`
  ${color};
`;

Option.defaultProps = {
  color: 'white',
};

Option.displayName = 'Option';

const getSelected = (selectedValue, items) =>
  items.find(({ value }) => value === selectedValue);

const PickerItems = ({
  items,
  placeholder,
  showPlaceholderOption,
  showPicker,
  onValueChange,
  onClick,
  onBlur,
  label,
  value,
  ...restProps
}) => {
  showPlaceholderOption = showPlaceholderOption && placeholder;
  if (showPlaceholderOption) {
    items = [{ label: placeholder, value: '' }, ...items];
  }

  const handleValueChange = event => {
    const { value: selectedValue } = event.target;
    if (!selectedValue) {
      onValueChange(null, -1);
    }

    const selected = getSelected(selectedValue, items);
    const selectedIndex = items.indexOf(selected);
    onValueChange(selected, selectedIndex - (showPlaceholderOption ? 1 : 0));
  };

  return (
    <Select
      {...restProps}
      value={value}
      onChange={handleValueChange}
      onClick={onClick}
      onBlur={onBlur}
    >
      {items.map(({ label, previousLabel, value }, index) => (
        <Option value={value} label={label} key={index}>
          {previousLabel || label}
        </Option>
      ))}
    </Select>
  );
};

PickerItems.propTypes = {
  items: PropTypes.array,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onValueChange: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  showPlaceholderOption: PropTypes.bool,
  showPicker: PropTypes.bool,
};

PickerItems.displayName = 'PickerItemsMobile';

export default PickerItems;
